
import React from "react";
import { CheckCircle } from "lucide-react";

// WhatsApp Leads Data
const whatsappLeadsData = [
  {
    heading: "Attract More Customers to Your Spa & Salon",
    points: [
      "Run click-to-WhatsApp ads to grab customer interest quickly.",
      "Confirm interest and turn inquiries into solid leads.",
      "Book appointments and take payments right on WhatsApp for confirmed visits.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/spa_salon/spa_salon_2.png",
  },
  {
    heading: "Keep Customers Coming Back with WhatsApp Engagement",
    points: [
      "Send friendly appointment reminders to reduce no-shows.",
      "Promote special events, discounts, and offers via WhatsApp broadcasts.",
      "Share updates like closures or availability to keep clients informed.",
      "Make rescheduling or canceling appointments a breeze on WhatsApp.",
    ],
    // buttonText: "Get Start ",
    buttonText: "Meta Policy for Spa and Salons",
    buttonLink:"https://www.facebook.com/business/help/2489235377779939?id=434838534925385",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/spa_salon/spa_salon_3.png",
  },
  {
    heading: "Turn Appointments into More Sales Opportunities",
    points: [
      "Run quick surveys to learn what your customers love.",
      "Ask for feedback to improve and grow your services.",
      "Push referral and loyalty programs with exciting perks.",
      "Use automated WhatsApp messages to gather reviews effortlessly.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/spa_salon/spa_salon_4.png",
  },
];

const Saloncycle = () => {
  return (
    <>
      <div className="bg-gradient-to-r from-pink-200 to-pink-300 py-16 px-4">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-4xl font-bold text-gray-800">How WhatsApp Powers Spa & Salon Growth</h1>
          <div className="mt-4 mb-6 flex justify-center">
            <span className="w-20 h-1 bg-gray-400 rounded-full"></span>
          </div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">With WhatsApp Business API, you get easy-to-use tools for marketing, support, and sales that bring more clients through your doors.</p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 py-20">
        {whatsappLeadsData.map((item, index) => (
          <div key={index} className={`flex flex-col lg:flex-row items-center gap-16 my-20 ${index % 2 === 1 ? "lg:flex-row-reverse" : ""}`}>
            <div className="w-full lg:w-1/2">
              <img src={item.image} alt={item.heading} className="w-full h-auto rounded-lg  hover:scale-105 transition-transform" />
            </div>
            <div className="w-full lg:w-1/2">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">{item.heading}</h2>
              <ul className="space-y-4 text-gray-700">
                {item.points.map((point, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <CheckCircle className="text-[#075E54] w-5 h-5 flex-shrink-0" />
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
              {item.buttonText && (
               <a
               href={item.buttonLink}
               className="mt-6 inline-block bg-[#075E54] text-white py-3 px-6 rounded-lg hover:bg-[#064d40] transition-colors"
             >
               {item.buttonText}
             </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Saloncycle;